import { render, staticRenderFns } from "./ItemManage.vue?vue&type=template&id=d44dba82&scoped=true"
import script from "./ItemManage.vue?vue&type=script&lang=js"
export * from "./ItemManage.vue?vue&type=script&lang=js"
import style0 from "./ItemManage.vue?vue&type=style&index=0&id=d44dba82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d44dba82",
  null
  
)

export default component.exports